<h1 class="app-dialog-title" mat-dialog-title>{{ dialogTitle }}</h1>

<mat-dialog-content>
  @if (!qrCodeUrl()) {
    <p class="mat-body-1" i18n>
      Secure your account by enabling two-step verification using an app such as
      Google Authenticator, Authy, or Microsoft Authenticator.
    </p>
  } @else {
    <div class="qr-step">
      <p class="mat-body-1" i18n>
        <strong>1.</strong> Scan the QR code below in your app:
      </p>

      <div class="qr-container">
        <qrcode
          [qrdata]="qrCodeUrl()!"
          [width]="200"
          [errorCorrectionLevel]="'M'"
        />
      </div>

      <p class="mat-body-1" i18n>
        <strong>2.</strong> Enter the 6-digit code from the app to confirm:
      </p>

      <form [formGroup]="totpForm" class="code-form">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label i18n="@@6digitCodeInfo">6-digit code</mat-label>
          <input
            matInput
            formControlName="code"
            type="text"
            maxlength="6"
            autocomplete="off"
          />
        </mat-form-field>
      </form>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (loading()) {
    <mat-spinner [diameter]="36" color="primary" />
  } @else {
    <button matButton type="button" (click)="cancelSetup()" i18n="@@cancel">
      Cancel
    </button>

    @if (!qrCodeUrl()) {
      <button
        matButton="elevated"
        color="primary"
        (click)="generateSecret()"
        i18n="@@nextButton"
      >
        Next
      </button>
    } @else {
      <button
        matButton="elevated"
        color="primary"
        [disabled]="totpForm.invalid"
        (click)="verifyAndEnroll()"
        i18n="@@verifi&saveButton"
      >
        Verify and save
      </button>
    }
  }
</mat-dialog-actions>
